import React from 'react';
import { motion } from 'framer-motion';
export function HookSection() {
  return <section className="py-12 md:py-24 bg-white relative" data-id="element-66">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-10 md:h-16 bg-rosegold/30" data-id="element-67"></div>
      <div className="max-w-4xl mx-auto px-5 lg:px-8 text-center" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6
      }} data-id="element-69">
          <svg className="w-8 h-8 md:w-12 md:h-12 mx-auto mb-5 md:mb-8 text-rosegold/40" fill="currentColor" viewBox="0 0 24 24" data-id="element-70">
            <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" data-id="element-71" />
          </svg>
          <p className="text-xl md:text-3xl font-serif text-charcoal leading-relaxed mb-5 md:mb-8" data-id="element-72">
            Estás en el parque con tus hijos, alguien cuenta un chiste, te ríes
            con ganas y, de repente, sientes esa humedad humillante. O quizás
            vas a estornudar y, por instinto, cruzas las piernas con miedo.
          </p>
          <p className="text-base md:text-lg text-charcoal/70 leading-relaxed max-w-3xl mx-auto" data-id="element-73">
            Si vives con un protector diario "por si las dudas" o si tu vientre
            sigue pareciendo de embarazada meses después de dar a luz, quiero
            que sepas algo: no es normal, no tienes que "aguantarte", y no
            necesitas una cirugía para volver a ser tú misma.
          </p>
        </motion.div>
      </div>
    </section>;
}